const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const SalesExecutive = 'SalesExecutive'
const Financial = "Financial"
const Logistics = 'Logistics'
const Seller = 'Seller'
const CreditAnalyst = 'CreditAnalyst'

const DriverRoutes = [
  {
    path: '/drivers/create',
    name: 'DriverRegister',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    component: () => import('@/_backoffice/_registrations/components/drivers/NewDriver.vue'),
    children: [
      {
        path: 'exists/:id',
        name: 'DriverExist',
        component: () => import('@/_backoffice/_registrations/components/drivers/DriverExist.vue'),
      }
    ]
  },
  {
    path: '/drivers',
    name: 'DriversList',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    // component: () => import('@/components/depot/DriversList')
    component: () => import('@/_backoffice/_registrations/pages/Drivers.vue'),
    children:[
      {
        path: ':id',
        name: 'EditDriver',
        meta: {
          auth: true ,
          roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
        },
        component: () => import('@/_backoffice/_registrations/components/drivers/EditDriver.vue'),
      },
    ]
  },

]


export default DriverRoutes